import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/allplans.png'


const _withScopeId = n => (_pushScopeId("data-v-291df0cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-6" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Postpaid plans")
], -1))
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-6" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Prepaid plans")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-6 mx-md-15 mt-4" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "General Terms:"),
  /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"10px"} }, "* The above plans are for Home & Business use only. Data transfer includes upload/download data while browsing. Jtel will identify and treat any consumption by a customer beyond 3300 GB of data in a 30-day billing cycle; as misuse of the benefits provided. Upon reaching such limit in a billing cycle, Jtel reserves the right to withdraw the plan benefits in the form of data use for such consumer without giving any prior notice. Commercial use policy of 3300 GB applicable on all Truly Unlimited Plans,Customers to pay advance subscription charges while registering, for any plan change after expiry of lump sum period there will be no carry forward of unutilized data to the new plan. Any scheme change/reconnection/shifting/disconnection/ transfer will be acted based on the written request from the customer along with dues settlement, if any Fair usage policy applies to select unlimited packages. Internet service shall be provided only in areas where the service is technically feasible. The speed depends on the various factors including the bandwidth of server accessed. Speed will be offered on best effort basis. The scheme can be withdrawn at any point of time at the discretion of JTEL. Update your e-mail id/mobile number for receiving invoices/SMS alerts. The above plans are available only in select areas. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_jt_all_postpaid_plans = _resolveComponent("jt-all-postpaid-plans")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_jt_all_prepaid_plans = _resolveComponent("jt-all-prepaid-plans")!
  const _component_jt_need_guidance = _resolveComponent("jt-need-guidance")!
  const _component_jt_footer = _resolveComponent("jt-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "mt-3 mx-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex justify-center cursor-pointer" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, { src: _imports_0 })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_card, { class: "card-curved no-shadow mx-8 pt-10" }, {
        default: _withCtx(() => [
          _createVNode(_component_jt_all_postpaid_plans)
        ]),
        _: 1
      })
    ]),
    _hoisted_3,
    _createElementVNode("div", null, [
      _createVNode(_component_v_row, { class: "my-3 mx-8" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "d-flex justify-center cursor-pointer" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_chip_group, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: _normalizeClass(["btn-primary px-0 px-md-7 mr-1 mr-md-8", { 'active': $setup.mode == 'M' }]),
                    style: {"height":"50px"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.mode = 'M'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Monthly")
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_btn, {
                    class: _normalizeClass(["btn-primary px-0 px-md-7 mr-1 mr-md-8", { 'active': $setup.mode == 'H' }]),
                    style: {"height":"50px"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.mode = 'H'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Half Yearly")
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_btn, {
                    class: _normalizeClass(["btn-primary px-0 px-md-7", { 'active': $setup.mode == 'Y' }]),
                    style: {"height":"50px"},
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.mode = 'Y'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Yearly")
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, { class: "card-curved no-shadow mx-8 pt-10" }, {
        default: _withCtx(() => [
          _createVNode(_component_jt_all_prepaid_plans, { mode: $setup.mode }, null, 8, ["mode"])
        ]),
        _: 1
      })
    ]),
    _hoisted_4,
    _createVNode(_component_jt_need_guidance),
    _createVNode(_component_jt_footer)
  ], 64))
}